export default "__VITE_ASSET__c31358ea__"